// @flow
import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* stylelint-disable */
  min-height: -moz-available;
  min-height: -webkit-fill-available;
  min-height: fill-available;
  /* stylelint-enable */
  background-color: ${buildColor("navy", "700")};
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  flex-direction: column;
  justify-content: space-between;
  z-index: 1002;
`;

export default Container;
